import { render, staticRenderFns } from "./OurFooter.vue?vue&type=template&id=4993b7c5&scoped=true&"
var script = {}
import style0 from "./OurFooter.vue?vue&type=style&index=0&id=4993b7c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993b7c5",
  null
  
)

export default component.exports